import { Van } from '../models/van.model';

export interface VanState {
  vans: Van[];
  loading: boolean;
  error: string | null;
}

export const initialState: VanState = {
  vans: [],
  loading: false,
  error: null,
};
